import { defineNuxtPlugin } from "@nuxtjs/composition-api";

import { exposeConfig } from "@/utils/accessors/config";
import { type LogLevel } from "@/utils/logger/types";

/**
 * For some reason, it doesn't merge correctly when put into a .d.ts file
 * leaving Context and Vue references to config as loosely typed.
 */
declare module "@nuxt/types/config/runtime" {
  export interface NuxtRuntimeConfig {
    env?: string;
    version?: string;
    logLevel: LogLevel;
    isServer?: boolean;
    amplitude: {
      key: string;
      experimentsKey?: string;
    };
    apiGateway: {
      protocol: string;
      host?: string;
      services: ApiGatewayServiceMap;
    };
    mux: {
      envKey: string | undefined;
      playerName: string;
    };
    wishlists?: {
      sharedCollectionUserAllowList: string[] | boolean | null;
    };
    creatorSite: string;
    ltkMarketingSite: string;
  }
}

/**
 * Follow accessor pattern as outlined in the nuxt typescript cookbook.
 * https://typescript.nuxtjs.org/cookbook/store/#class-based
 */
export default defineNuxtPlugin(({ $config }) => {
  exposeConfig($config);
});
